if(contentGridCount != 1) {

    var contentGridCount = 1; //prevent script to be used more than once
    const contentGrid = document.querySelectorAll('.js-content-grid-main-item');

    contentGrid.forEach(item => item.addEventListener('click', () => {
        
        const contentMainItemArrow = item.querySelector('.content-grid__title');
        const arrowActive = contentMainItemArrow.classList.contains('invertArrow');

        //move all arrows to their initial position
        const allArrows = document.querySelectorAll('.js-content-grid-main-item .content-grid__title');
        allArrows.forEach((a) => a.classList.remove('invertArrow')); 

        let contentElement = document.querySelector('#js-content-grid-content-' + item.dataset.id);
        let contentClass = document.querySelectorAll('.content-grid__single-item__full-width-content');
        
        !arrowActive ? contentMainItemArrow.classList.add('invertArrow') : null;

        contentClass.forEach((e) => e.style.display = 'none'); // hide all contents
        !arrowActive ? contentElement.style.display = "block" : null; // display one content element

        if(!arrowActive){
            document.querySelector(".content-grid__title.invertArrow").scrollIntoView({ 
                behavior: 'smooth' 
            });    
        }else{
            item.scrollIntoView({ 
                behavior: 'smooth' 
            });  
        }
        

    }));

    const all_richtexts_with_br = document.querySelectorAll(".add_break_line");

    all_richtexts_with_br.forEach(child => {
        const allParagraphs = child.querySelectorAll("P");
        allParagraphs.forEach(p => {

            console.log(p.textContent);

            if(!p.textContent){
                const br = document.createElement("br");
                p.appendChild(br);
            }

        })
    })

}
